<template>
  <div :style="styles">
    <span>HERE</span>
  </div>
</template>

<script>
export default {
  name: 'TableLabel',
  props: {
    table: {
      type: Object,
      default () {return {}}
    }
  },
  data () {
    return {}
  },
  computed: {
    styles () {
      const {height, width, x, y, rotation, skewX, skewY, scaleX, scaleY} = this.table
      const transform = 'skewX(' + skewX + 'deg) skewY(' + skewY + 'deg) rotate(' + rotation + 'deg) scaleX(' + scaleX + ') scaleY(' + scaleY + ') translate(' + x + 'px, ' + y + 'px)'
      return {height, width, transform}
    }
  }
}
</script>